import React, { Component } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, withStyles, Modal, Box } from '@material-ui/core';
import api from 'services/api';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import DeleteConfirmationModal from 'components/DeleteConfirmationModal/DeleteConfirmationModal';
import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField';
import AlertInformation from 'components/AlertInformation/AlertInformation';

const styles = (theme) => ({
    table: {
        minWidth: 650,
    },
    dialogContent: {
        wordWrap: 'break-word',
    },
    dialogTitle: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
    },
    tableContainer: {
        // marginTop: theme.spacing(2),
    },
    tableCell: {
        paddingTop: 5,
        paddingBottom: 5
    }
});

class ComissaoVendedorServico extends Component {
    constructor(props) {
        super(props);
        this.state = {
            comissoes: [],
            qtdeServ: 0,
            openAlert: false,
            messageAlert: '',
        };
    };

    // Método para buscar os dados da API ao montar o componente
    componentDidMount() {
        const { codVendedor, comissaoServicos } = this.props;

        if (codVendedor) {
            this.fetchComissoes(codVendedor);
        } else {
            if (comissaoServicos.length) {
                this.setState({
                    comissoes: comissaoServicos,
                    // qtdeServ: comissaoServicos.length
                    qtdeServ: 10
                });
            } else {
                this.fetchComissoes(0);
            }
        }
    };

    // Faz a requisição à API para obter as comissões
    fetchComissoes = async (codVendedor) => {
        try {
            const response = await api.get(`/vendedor/comissaoservico/${codVendedor}`);
            this.setState({
                comissoes: response.data,
                // qtdeServ: response.data.length
                qtdeServ: 10
            });
        } catch (error) {
            console.error('Erro ao buscar comissões de serviços:', error);
        }
    };

    /* evento on change componentes */
    OnChange = (event) => {
        const { comissoes } = this.state;
        const { name, value, id } = event.target;
        let adjustedValue = value;

        adjustedValue = Number(value.replace(/\./g, '').replace(',', '.'));

        comissoes[id][name] = adjustedValue;
    }

    onClickSave = () => {
        this.atualizaComissaoServico();
    }

    handleCancel = () => {
        this.props.onClose();
    };

    atualizaComissaoServico = async () => {
        const { comissoes } = this.state;
        const { codVendedor } = this.props;

        if (codVendedor) {
            let comissaoservico = []
            for (let i = 0; i <= comissoes.length - 1; i++) {
                if ((comissoes[i].perccomissao > 0) || (comissoes[i].valorporpax > 0) ||
                    (comissoes[i].valorporpaxchd > 0) || (comissoes[i].valorporpaxinf > 0) ||
                    (comissoes[i].valorporpaxsen > 0)) {
                    comissaoservico.push(
                        {
                            codservico: comissoes[i].codservico,
                            perccomissao: comissoes[i].perccomissao,
                            valorporpax: comissoes[i].valorporpax,
                            valorporpaxchd: comissoes[i].valorporpaxchd,
                            valorporpaxinf: comissoes[i].valorporpaxinf,
                            valorporpaxsen: comissoes[i].valorporpaxsen,
                            // calculacomissobreliquido: comissoes[i].calculacomissobreliquido
                        }
                    )
                }
            }

            try {
                const response = await api.post(`/vendedor/comissaoservico/${codVendedor}`, comissaoservico);
                if (response.status === 200) {
                    this.props.onClose();
                }
            } catch (error) {
                this.handleOpenAlert(error.response.data.error);
            }
        } else {
            this.props.onSave(comissoes);
        }
    };

    handleOpenAlert = (message) => {
        this.setState({ openAlert: true, messageAlert: message });
    };

    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    render() {
        const { comissoes, qtdeServ } = this.state;
        const { classes } = this.props;

        return (
            <div>
                <div>
                    <TableContainer component={Paper} className={classes.tableContainer} style={{ maxHeight: 400 }}>
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableCell}>Código</TableCell>
                                    <TableCell className={classes.tableCell}>Serviço</TableCell>
                                    <TableCell className={classes.tableCell}>% Comissão</TableCell>
                                    <TableCell className={classes.tableCell}>Valor pax ADT</TableCell>
                                    <TableCell className={classes.tableCell}>Valor pax CHD</TableCell>
                                    <TableCell className={classes.tableCell}>Valor pax INF</TableCell>
                                    <TableCell className={classes.tableCell}>Valor pax SEN</TableCell>
                                    {/* <TableCell>Deduz Comiss. Líq.</TableCell>                                     */}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {comissoes.slice(0, qtdeServ).map((comissao, index) => (
                                    <TableRow key={comissao.codservico}>
                                        <TableCell className={classes.tableCell}>{comissao.codservico}</TableCell>
                                        <TableCell className={classes.tableCell}>{comissao.descservico}</TableCell>
                                        <TableCell className={classes.tableCell}>
                                            {/* {comissao.perccomissao || '0,00'} */}
                                            <CurrencyTextField
                                                // className={this.state.useStyles.textField}
                                                label=""
                                                // style={{ marginRight: '10px', marginTop: '20px', width: '225px' }}
                                                name="perccomissao"
                                                id={String(index)}
                                                value={comissao.perccomissao || '0'}
                                                // variant="outlined"
                                                currencySymbol=""
                                                outputFormat="number"
                                                decimalCharacter=","
                                                digitGroupSeparator="."
                                                onChange={this.OnChange}
                                                // disabled={this.state.isView}
                                                minimumValue="0"
                                            />
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            {/* {comissao.valorporpax || '0,00'} */}
                                            <CurrencyTextField
                                                // className={this.state.useStyles.textField}
                                                label=""
                                                // style={{ marginRight: '10px', marginTop: '20px', width: '225px' }}
                                                name="valorporpax"
                                                id={String(index)}
                                                value={comissao.valorporpax || '0'}
                                                // variant="outlined"
                                                currencySymbol=""
                                                outputFormat="number"
                                                decimalCharacter=","
                                                digitGroupSeparator="."
                                                onChange={this.OnChange}
                                                // disabled={this.state.isView}
                                                minimumValue="0"
                                            />
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            {/* {comissao.valorporpaxchd || '0,00'} */}
                                            <CurrencyTextField
                                                // className={this.state.useStyles.textField}
                                                label=""
                                                // style={{ marginRight: '10px', marginTop: '20px', width: '225px' }}
                                                name="valorporpaxchd"
                                                id={String(index)}
                                                value={comissao.valorporpaxchd || '0'}
                                                // variant="outlined"
                                                currencySymbol=""
                                                outputFormat="number"
                                                decimalCharacter=","
                                                digitGroupSeparator="."
                                                onChange={this.OnChange}
                                                // disabled={this.state.isView}
                                                minimumValue="0"
                                            />
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            {/* {comissao.valorporpaxinf || '0,00'} */}
                                            <CurrencyTextField
                                                // className={this.state.useStyles.textField}
                                                label=""
                                                // style={{ marginRight: '10px', marginTop: '20px', width: '225px' }}
                                                name="valorporpaxinf"
                                                id={String(index)}
                                                value={comissao.valorporpaxinf || '0'}
                                                // variant="outlined"
                                                currencySymbol=""
                                                outputFormat="number"
                                                decimalCharacter=","
                                                digitGroupSeparator="."
                                                onChange={this.OnChange}
                                                // disabled={this.state.isView}
                                                minimumValue="0"
                                            />
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            {/* {comissao.valorporpaxsen || '0,00'} */}
                                            <CurrencyTextField
                                                // className={this.state.useStyles.textField}
                                                label=""
                                                // style={{ marginRight: '10px', marginTop: '20px', width: '225px' }}
                                                name="valorporpaxsen"
                                                id={String(index)}
                                                value={comissao.valorporpaxsen || '0'}
                                                // variant="outlined"
                                                currencySymbol=""
                                                outputFormat="number"
                                                decimalCharacter=","
                                                digitGroupSeparator="."
                                                onChange={this.OnChange}
                                                // disabled={this.state.isView}
                                                minimumValue="0"
                                            />
                                        </TableCell>
                                        {/* <TableCell>{comissao.calculacomisssobreliquido}</TableCell> */}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>

                <Box style={{ float: 'right' }}>
                    <Button
                        color="primary"
                        onClick={this.onClickSave}
                        style={{ marginRight: '5px' }}
                    >
                        Salvar
                    </Button>

                    <Button
                        color="primary"
                        onClick={this.handleCancel}
                    >
                        Fechar
                    </Button>
                </Box>

                <div>
                    <AlertInformation
                        open={this.state.openAlert}
                        handleClose={this.handleCloseAlert}
                        message={this.state.messageAlert}
                    />
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(ComissaoVendedorServico);